<ul *ngIf="list.length">
  <li *ngFor="let item of list">{{ item | translate }}</li>
</ul>
